import exit from "../../../src/Utils/Images/Logout 2.png";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import workout from "../../../src/Utils/Images/workout.png";
import workoutfill from "../../../src/Utils/Images/workoutfill.png";
import logo from "../../Utils/Images/logo192.png";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Modal,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import sidebarArray from "./Sidebar.dto";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Drawer, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import thick from "../../../src/Utils/Images/LineThick.png";
import line from "../../../src/Utils/Images/Line.png";
import CustomButton from "../Button/CustomButton";

const Sidebar = () => {
  const role = localStorage.getItem("role");
  const privilleges =
    JSON.parse(localStorage.getItem("privillegesArray")) || [];

  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const location = useLocation().pathname;
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(true);

  const handleResize = () => {
    window.innerWidth <= 900 ? setDrawerOpen(false) : setDrawerOpen(true);
  };
  const handleDrawerToggle = () => {
    window.innerWidth <= 900 ? setDrawerOpen(!drawerOpen) : setDrawerOpen(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleAccordin = (e) => {
    if (e.title !== "Workout") {
      setIsAccordionOpen(false);
    } else {
      if (
        location !== "workoutplans" ||
        location !== "recipeplans" ||
        location !== "dietplans" ||
        location !== "weeklychallanges" ||
        location !== "questions"
      ) {
        setIsAccordionOpen(true);
      } else {
        setIsAccordionOpen(!isAccordionOpen);
      }
    }
  };
  const handleLogoutConfirmed = () => {
    navigate("/login");
    localStorage.removeItem("token");
    localStorage.removeItem("apikey");
    setOpen(false);
  };
  useEffect(() => {
    handleResize(); // Initial check to set the state based on the screen size when the component mounts
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Box sx={{ boxSizing: "border-box" }}>
        {/* Mobile Menu */}
        <IconButton
          onClick={handleDrawerToggle}
          sx={{ display: { md: "none", sm: "block" } }}
        >
          <MenuIcon />
        </IconButton>
        {/* Drawer (for smaller screens) */}
        <Drawer
          anchor="left"
          variant="persistent"
          open={drawerOpen}
          onClose={handleDrawerToggle}
        >
          {/* Sidebar Content */}
          <Box
            sx={{
              m: "auto",
              width: "100%",
              alignItems: "center",
              background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
              position: "absolute",
            }}
          >
            <Box
              sx={{
                m: "auto",
                mt: "25px",
                width: "65%",
                alignItems: "center",
                background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
              }}
            >
              <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                <Box sx={{ width: "60px", height: "50px" }}>
                  <img width={"100%"} height={"100%"} src={logo} alt="photo" />
                </Box>
                <Typography
                  sx={{
                    fontFamily: "inter",
                    fontWeight: "700",
                    fontSize: "32px",
                    lineHeight: "32px",
                    textAlign: "left",
                  }}
                >
                  QHealth
                </Typography>
              </Box>
              <Box sx={{ display: "flex", justifyContent: "end", mt: "-10px" }}>
                <Typography
                  sx={{
                    textAlign: "left",
                    fontFamily: "inter",
                    fontWeight: "500",
                    fontSize: "20px",
                  }}
                >
                  Admin
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              background: `linear-gradient(0deg, #FBFBFB, #FBFBFB)`,
              width: "290px",
            }}
          >
            <Box
              sx={{
                m: "auto",
                mt: "10px",
                width: "65%",
                alignItems: "center",
                display: { md: "none", sm: "block" },
              }}
            >
              <IconButton
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
                onClick={handleDrawerToggle}
              >
                <MenuIcon />
              </IconButton>
            </Box>
            <Box
              sx={{
                width: "100%",
                m: "auto",
                mt: "100px",
                overflow: "auto",
                height: "900px",
              }}
            >
              {sidebarArray
                .filter((e) => privilleges.includes(e.id))
                .map((e, i) => (
                  <Box
                    key={i}
                    sx={{
                      overflow: "hidden",
                      transition: "opacity 0.3s ease-in-out",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                      bgcolor:
                        e.path === location && !isAccordionOpen
                          ? "#31AEF4"
                          : "",
                    }}
                    onClick={() => {
                      handleAccordin(e);
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        m: "auto",
                        justifyContent: "start",
                        alignItems: "center",
                        p: "10px 40px 10px 40px",
                      }}
                    >
                      {e.title === "Workout" ? (
                        ""
                      ) : (
                        <img
                          width={"25px"}
                          src={
                            e.path === location && isAccordionOpen === false
                              ? e.active
                              : e.image
                          }
                          alt="logo"
                        />
                      )}
                      <Link style={{ textDecoration: "none" }} to={e.path}>
                        <Box
                          onClick={handleDrawerToggle}
                          sx={{
                            display: "flex",
                            width: "200px",
                            height: "50px",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              ml: "10px",
                              textAlign: "left",
                              fontFamily: "inter",
                              fontSize: "20px",
                              fontWeight: "500",
                              lineHeight: "20px",
                              cursor: "pointer",
                              color:
                                e.path === location && isAccordionOpen === false
                                  ? "#FFFFFF"
                                  : "#737373",
                            }}
                          >
                            {e.title === "Workout" ? "" : e.title}
                          </Typography>
                        </Box>
                      </Link>

                      {e.title === "Workout" ? (
                        <Box sx={{ ml: "-250px" }}>
                          <Accordion
                            open={isAccordionOpen}
                            sx={{
                              boxShadow: 0,
                              p: 1,
                              borderRadius: "50%",
                              width: "85%",
                              bgcolor: "#FBFBFB",
                            }}
                            onClick={() => setIsAccordionOpen(!isAccordionOpen)}
                          >
                            <AccordionSummary
                              expandIcon={
                                <KeyboardArrowDownOutlinedIcon fontSize="large" />
                              }
                              aria-controls="panel1bh-content"
                              id="panel1bh-header"
                              sx={{
                                height: "70px",
                                bgcolor: isAccordionOpen
                                  ? "#31AEF4"
                                  : "#FBFBFB",
                                width: "295px",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: "10px",
                                  ml: "20px",
                                  width: "30px",
                                  height: "30px",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  width={"100%"}
                                  height={"100%"}
                                  src={isAccordionOpen ? workoutfill : workout}
                                  alt=""
                                />
                                <Typography
                                  sx={{
                                    ml: "10px",
                                    textAlign: "left",
                                    fontFamily: "inter",
                                    fontSize: "20px",
                                    fontWeight: "500",
                                    lineHeight: "20px",
                                    cursor: "pointer",
                                    color: isAccordionOpen
                                      ? "#FFFFFF"
                                      : "#737373",
                                  }}
                                >
                                  Workout
                                </Typography>
                              </Box>
                            </AccordionSummary>

                            {/* new */}
                            <AccordionDetails
                              sx={{ width: "265px", ml: "13px " }}
                            >
                              {e?.optionsArray?.map((el, i) => (
                                <Box
                                  key={i}
                                  sx={{
                                    display: "flex",
                                    textAlign: "left",
                                    alignItems: "center",
                                    gap: "10px",
                                    height: "20px",
                                    ml: "12px",
                                    mt: "15px",
                                    transition: "opacity 0.3s ease",
                                    "&:hover": {
                                      transform: "scale(1.05)",
                                    },
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "30px",
                                      height: "3px",
                                      marginLeft:
                                        el.path === location.replace("/", "")
                                          ? "15px"
                                          : 0,
                                    }}
                                    src={line}
                                    alt=""
                                  />
                                  <Link
                                    style={{ textDecoration: "none" }}
                                    to={`/${el.path}`}
                                  >
                                    <Typography
                                      sx={{
                                        textAlign: "left",
                                        fontFamily: "inter",
                                        fontSize: "16px",
                                        fontWeight: "500",
                                        lineHeight: "16px",
                                        cursor: "pointer",
                                        mr: "50px",
                                        color:
                                          e.path === location.pathname
                                            ? "#fff"
                                            : "#737373",
                                      }}
                                      key={el.id}
                                    >
                                      {el.opt}
                                    </Typography>
                                  </Link>
                                </Box>
                              ))}
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ) : (
                        ""
                      )}
                    </Box>
                  </Box>
                ))}

              <Box
                sx={{
                  width: "240px",
                  m: "auto",
                  mt: "12px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    gap: "15px",
                    alignItem: "center",
                    ml: "20px",
                    transition: "opacity 0.3s ease-in-out",
                    "&:hover": {
                      transform: "scale(1.05)",
                    },
                  }}
                >
                  <img src={exit} alt="logo" />
                  <Typography
                    sx={{
                      textAlign: "left",
                      fontFamily: "inter",
                      fontSize: "20px",
                      fontWeight: "500",
                      lineHeight: "20px",
                      cursor: "pointer",
                      color: "#737373",
                      mt: "5px",
                    }}
                    onClick={handleClickOpen}
                  >
                    Log Out
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </Drawer>
      </Box>
      {/* Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            boxShadow: 24,
            borderRadius: "20px",
            outline: "none",
            p: 4,
            bgcolor: "white",
          }}
        >
          <Typography variant="h6" component="h2">
            Are you sure you want to log out?
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <HelpOutlineIcon
              sx={{ width: "75px", height: "100px", color: "#31AEF4" }}
            />
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "center", gap: 5, mt: 2 }}
          >
            <CustomButton onClick={handleLogoutConfirmed}>Yes</CustomButton>
            <CustomButton onClick={handleClose}>No</CustomButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Sidebar;
